// extracted by mini-css-extract-plugin
module.exports = {"list":"MultiSelectForm__list--25K","option":"MultiSelectForm__option--3vX"};